(() => {
  const mq = window.matchMedia('(min-width: 990px)');
  let initialized = false;

  let menuItems = [];
  let allDetails = [];

  function onMouseEnter(details) {
    return function () {
      // Close all others
      allDetails.forEach(d => {
        if (d !== details) {
          d.removeAttribute('open');
          d.classList.remove('active');
        }
      });

      details.setAttribute('open', true);
      details.classList.add('active');
    };
  }

  function onMouseLeave(details) {
    return function () {
      details.removeAttribute('open');
      details.classList.remove('active');
    };
  }

  function initDesktopMenu() {
    if (initialized) return;
    initialized = true;

    menuItems = Array.from(document.querySelectorAll('.list-menu > li'));
    allDetails = Array.from(document.querySelectorAll('.list-menu > li > details'));

    menuItems.forEach(item => {
      const details = item.querySelector('details');
      if (!details) return;

      item._enterHandler = onMouseEnter(details);
      item._leaveHandler = onMouseLeave(details);

      item.addEventListener('mouseenter', item._enterHandler);
      item.addEventListener('mouseleave', item._leaveHandler);
    });
  }

  function destroyDesktopMenu() {
    if (!initialized) return;
    initialized = false;

    menuItems.forEach(item => {
      if (item._enterHandler) {
        item.removeEventListener('mouseenter', item._enterHandler);
        item.removeEventListener('mouseleave', item._leaveHandler);
        delete item._enterHandler;
        delete item._leaveHandler;
      }
    });

    // Cleanup open states
    allDetails.forEach(d => {
      d.removeAttribute('open');
      d.classList.remove('active');
    });
  }

  function handleChange(e) {
    if (e.matches) {
      initDesktopMenu();
    } else {
      destroyDesktopMenu();
    }
  }

  // Run on load
  document.addEventListener('DOMContentLoaded', () => {
    handleChange(mq);
  });

  // Run on resize
  mq.addEventListener('change', handleChange);
})();
